import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const EyeClose = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      d="M4.714 3.294a1.004 1.004 0 1 0-1.42 1.42l5.63 5.63a3.5 3.5 0 0 0 4.74 4.74l5.63 5.63a1 1 0 0 0 1.42 0 1.002 1.002 0 0 0 0-1.42l-16-16Zm7.29 10.21a1.5 1.5 0 0 1-1.5-1.5v-.07l1.56 1.56-.06.01Z"
      fill={color}
    />
    <Path
      d="M12.224 17.004c-4.3.1-7.12-3.59-8-5 .626-1 1.38-1.913 2.24-2.72l-1.46-1.41a15.89 15.89 0 0 0-2.87 3.63 1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25a9.481 9.481 0 0 0 3.23-.67l-1.58-1.58a7.74 7.74 0 0 1-1.7.25ZM21.874 11.504c-.64-1.11-4.17-6.68-10.14-6.5a9.48 9.48 0 0 0-3.23.67l1.58 1.58a7.74 7.74 0 0 1 1.7-.25c4.29-.11 7.11 3.59 8 5a13.705 13.705 0 0 1-2.29 2.72l1.51 1.41a15.893 15.893 0 0 0 2.91-3.63 1 1 0 0 0-.04-1Z"
      fill={color}
    />
  </Svg>
);

export default EyeClose;
